import type { SVGProps } from 'react';

const DashboardIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 36 36"
      fill="currentColor"
      {...props}
    >
      <path d="M15 2C16.1046 2 17 2.89543 17 4V32C17 33.1046 16.1046 34 15 34H4C2.89543 34 2 33.1046 2 32V4C2 2.89543 2.89543 2 4 2H15ZM32 19C33.1046 19 34 19.8954 34 21V32C34 33.1046 33.1046 34 32 34H21C19.8954 34 19 33.1046 19 32V21C19 19.8954 19.8954 19 21 19H32ZM4.73047 31.2695H14.2695V4.73047H4.73047V31.2695ZM21.7305 31.2695H31.2695V21.7305H21.7305V31.2695ZM32 2C33.1046 2 34 2.89543 34 4V15C34 16.1046 33.1046 17 32 17H21C19.8954 17 19 16.1046 19 15V4C19 2.89543 19.8954 2 21 2H32ZM21.7305 14.2695H31.2695V4.73047H21.7305V14.2695Z" />
    </svg>
  );
};
export default DashboardIcon;
